'use client';

import '@/app/global.css';
import React from 'react';
import errorService from '@razorpay/universe-cli/errorService/nextjs';
import ErrorBoundary from '@razorpay/universe-cli/errorService/ErrorBoundary';
import Layout from '@/shared/Layout';
import StyledComponentsRegistry from '@/lib/registry';
import '@/utils/hotjar';
declare const __VERSION__: string;
declare const __APP_NAME__: string;

if (process.env.STAGE !== 'development' && process.env.UNIVERSE_PUBLIC_SENTRY_DSN) {
  errorService.init({
    dsn: process.env.UNIVERSE_PUBLIC_SENTRY_DSN,
    environment: process.env.STAGE as string,
    version: `${__APP_NAME__}@${__VERSION__}`,
  });
}

export default function RootLayout({ children }: { children: React.ReactNode }): JSX.Element {
  return (
    <html lang="en">
      <body>
        <ErrorBoundary>
          <StyledComponentsRegistry>
            <Layout>{children}</Layout>
          </StyledComponentsRegistry>
        </ErrorBoundary>
      </body>
    </html>
  );
}
